"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.remove = remove;
exports.rename = rename;
exports.move = move;
exports.add = add;

var _immutable = _interopRequireDefault(require("immutable"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v2/folders';
var DEFAULT_QUERY = {
  deleted_at: 0,
  order_by: 'name',
  offset: 0,
  limit: -1
};

function parseQuery(options) {
  var query = {};

  if (options.get('search')) {
    query.name__icontains = options.get('search');
  }

  if (options.has('offset')) {
    query.offset = options.get('offset');
  }

  return Object.assign({}, DEFAULT_QUERY, query);
}

function fetch() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _immutable.default.Map();
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var earlyRequesterPromise = arguments.length > 2 ? arguments[2] : undefined;
  var URI = options.get('path') ? BASE_URI + "/path/" + encodeURIComponent(options.get('path')) : BASE_URI;
  var promise = earlyRequesterPromise || httpClient.get(URI, {
    query: parseQuery(options),
    // TODO: Remove once folder endpoint is paginated/fixed, call takes over 30 seconds on portal 53
    timeout: 60000
  });
  return promise.then(_immutable.default.fromJS);
}

function remove(folderId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.delete(BASE_URI + "/" + folderId);
}

function rename(folderId, newName) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var URI = BASE_URI + "/" + folderId + "/move-folder";
  return httpClient.post(URI, {
    data: {
      name: newName
    }
  }).then(_immutable.default.fromJS);
}

function move(folderId, parentId) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var URI = BASE_URI + "/" + folderId + "/move-folder";
  return httpClient.post(URI, {
    data: {
      parent_folder_id: parentId
    }
  }).then(_immutable.default.fromJS);
}

function add(folder) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var folderData = {
    name: folder.name,
    parent_folder_id: folder.parentId
  };
  return httpClient.post(BASE_URI, {
    data: folderData
  }).then(_immutable.default.fromJS);
}